/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import './capitalizeFirstLetter.js';
import './file.js';
import './humanize.js';
import './i18nfilter.js';
import './mobile.js';
import './moment.js';
import './objectFilterBy.js';
import './objectOrderBy.js';
import './ordinal.js';
import './pluralize.js';
import './range.js';
import './replace.js';
import './salesforce.js';

/**
 * Grouping module used for including all filter sub-modules.
 */
angular.module('sbsf.filters', [
  'filters.capitalizeFirstLetter',
  'filters.file',
  'filters.humanize',
  'filters.i18n',
  'filters.mobile',
  'filters.moment',
  'filters.objectFilterBy',
  'filters.objectOrderBy',
  'filters.ordinal',
  'filters.pluralize',
  'filters.range',
  'filters.replace',
  'filters.salesforce'
]);
